import { Injectable } from '@angular/core';
import { EntityManager } from '@proximus/entity-manager';
import {
  GetModemSafetySettingsEntity,
  GetWifiSsidEntity,
  MacIpAddressEntity,
  UpdateInternetPasswordEntity,
  UpdateModemSafetySettingsEntity,
  UpdateSharedIpSettingsEntity,
  UpdateWifiSsidEntity,
} from '../configs/entity.config';
import { InternetPasswordModel } from '@dch/products-business-logic/src/shared/models/internet-settings-password.model';
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class InternetSettingsService {
  constructor() {}

  updateInternetPassword(payload: InternetPasswordModel) {
    const params = {
      login: payload.login,
      internetPassword: payload.internetPassword,
    };
    const iEntity = EntityManager.createEntity(
      UpdateInternetPasswordEntity,
      {},
    );
    iEntity.value = params;
    return EntityManager.saveEntity(iEntity);
  }

  getModemSafety(loginId: string) {
    return EntityManager.getEntity(GetModemSafetySettingsEntity, {
      loginId,
    });
  }

  updateModemSafety(payload: { login: string; technicalProfile: string }) {
    const params = {
      login: payload.login,
      technicalProfile: payload.technicalProfile,
    };
    const iEntity = EntityManager.createEntity(
      UpdateModemSafetySettingsEntity,
      {},
    );
    iEntity.value = params;
    return EntityManager.saveEntity(iEntity);
  }

  updateCgnSettings(login: string) {
    const params = {
      login,
    };
    const iEntity = EntityManager.createEntity(
      UpdateSharedIpSettingsEntity,
      {},
    );
    iEntity.value = params;
    return EntityManager.saveEntity(iEntity);
  }

  getWifiSsid(accessNumber: string) {
    return EntityManager.getEntity(GetWifiSsidEntity, {
      accessNumber,
    });
  }

  updateWifiSsid(payload: { accessNumber: string; wifiSsid: string }) {
    const params = {
      wifissid: payload.wifiSsid,
    };
    const iEntity = EntityManager.createEntity(UpdateWifiSsidEntity, {
      accessNumber: payload.accessNumber,
    });
    iEntity.value = params;
    return EntityManager.saveEntity(iEntity);
  }

  updateMacIpAddress(payload: {
    circuitId: string;
    fixedIpMacAddress: string;
  }) {
    const params = {
      fixedIpMacAddress: payload.fixedIpMacAddress,
    };
    const iEntity = EntityManager.createEntity(MacIpAddressEntity, {
      circuitId: payload.circuitId,
    });
    iEntity.value = params;
    return EntityManager.updateEntity(iEntity);
  }

  addMacIpAddress(payload: { circuitId: string; fixedIpMacAddress: string }) {
    const params = {
      fixedIpMacAddress: payload.fixedIpMacAddress,
    };
    const iEntity = EntityManager.createEntity(MacIpAddressEntity, {
      circuitId: payload.circuitId,
    });
    iEntity.value = params;
    return EntityManager.saveEntity(iEntity);
  }

  getMacIpAddress(circuitId: string) {
    return EntityManager.getEntity(MacIpAddressEntity, { circuitId });
  }

  deleteMacIpAddress(circuitId: string) {
    return EntityManager.deleteEntity(
      EntityManager.createEntity(MacIpAddressEntity, { circuitId }),
    );
  }
}
